import getJsonSection from './getJsonSection'
import getJsonForm from './getJsonForm'

export const getJsonSectionPromise = getJsonSection
export const getJsonFormPromise = getJsonForm
